import { QueryClient } from '@tanstack/react-query'

import { queryConfig } from '@/config/queryClient'

// Create a singleton QueryClient instance that can be imported anywhere
export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
})
